import { makeBIMDataApiClient } from "@bimdata/typescript-fetch-api-client";
import { isOfflineMode } from "@/composables/network/offlineMode";
import { OfflineError } from "@/utils/errors";
async function detectMimeType(file) {
  if (file.type) {
    return file.type;
  }
  const buffer = await file.slice(0, 8).arrayBuffer();
  const bytes = new Uint8Array(buffer);

  const hex = Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  if (hex.startsWith("89504e47")) return "image/png";
  if (hex.startsWith("ffd8ff")) return "image/jpeg";
  if (hex.startsWith("25504446")) return "application/pdf";
  if (hex.startsWith("47494638")) return "image/gif";
  if (hex.startsWith("504b0304")) return "application/zip";

  return "application/octet-stream"; // fallback
}

const apiUrl = import.meta.env.VITE_APP_BD_API_BASE_URL;
let collaborationApi;

const initBimdataAuth = (accessToken) => {
  collaborationApi = makeBIMDataApiClient({
    apiUrl,
    accessToken,
  }).collaborationApi;
};

const uploadFile = async (projectOriginId, file) => {
  if (isOfflineMode()) throw new OfflineError();
  if (!collaborationApi) {
    throw new Error("BIMData API client is not initialized");
  }
  const fileType = await detectMimeType(file);

  try {
    const response = await collaborationApi.createDocument({
      cloudPk: import.meta.env.VITE_APP_CLOUD_ID,
      projectPk: projectOriginId,
      name: file.name,
      file: file,
    });
    return {
      id: response.id,
      mimeType: fileType,
      size: file.size,
      fileName: file.name,
    };
  } catch (e) {
    console.error("Error uploading file to BIMData:", e);
    throw e;
  }
};

export { initBimdataAuth, collaborationApi, uploadFile };
